export default {
      id: "ic_game_not_found-usage",
      viewBox: "0 0 153 154",
      url: "/" + "images/icons.3.109.2.svg#ic_game_not_found-usage",
      toString: function () {
        return this.url;
      }
    }